import React from "react";
import { Row, Col, Typography, Button } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";

import { APP_CONFIG } from "../composant/appConfig";

const { Title } = Typography;

const Footer = () => {
  const phone = APP_CONFIG.phone;
  const whatsappLink = `https://wa.me/${phone}`;

  return (
    <>
      <style>{`
        .footer {
          background: #111;
          color: #fff;
          padding: 40px 20px 20px;
          margin-top: 40px;
        }

        .footer-container {
          max-width: 1200px;
          margin: auto;
        }

        .footer h4, .footer p {
          color: #fff !important;
        }

        .footer-bottom {
          text-align: center;
          margin-top: 20px;
          border-top: 1px solid #333;
          padding-top: 15px;
          font-size: 12px;
          opacity: 0.7;
        }

        .whatsapp-btn {
          background-color: #edbb05 !important;
          border: none;
          width: 100%;
        }

        .whatsapp-btn:hover {
          background-color: #d4a605 !important;
        }

        /* LOGO */
        .footer-logo {
          height: 70px;
          object-fit: contain;
          display: block;
          margin-bottom: 10px;
        }

        @media (max-width: 768px) {
          .footer {
            text-align: center;
          }

          .footer-logo {
            margin: 0 auto 10px;
          }
        }
      `}</style>

      <div className="footer">
        <div className="footer-container">

          <Row gutter={[20, 20]}>
            
            {/* COL 1 → LOGO */}
            <Col xs={24} md={8}>

             {/* fallback texte */}
              <Title level={5} style={{ color: "white", margin: 0 }}>
                Restaurant Sadem
              </Title>


              <img
                src="/logo.png"   // 👉 mettre dans public/logo.png
                alt="Restaurant Sadem"
                className="footer-logo"
              />

             
            </Col>

            {/* COL 2 */}
            <Col xs={24} md={8}>
              <Title level={5} style={{color:"white"}}>Horaires</Title>
              <p>Lundi - Dimanche</p>
              <p>8h - 04h</p>
            </Col>

            {/* COL 3 */}
            <Col xs={24} md={8}>
              <Title level={5}>Commander</Title>

              <Button
                type="primary"
                icon={<WhatsAppOutlined />}
                href={whatsappLink}
                target="_blank"
                className="whatsapp-btn"
              >
                WhatsApp
              </Button>
            </Col>

          </Row>

          {/* BAS */}
          <div className="footer-bottom">
            © {new Date().getFullYear()} Restaurant Sadem — Tous droits réservés
          </div>

        </div>
      </div>
    </>
  );
};

export default Footer;